<template>
  <div class="toggle-block__details-body">
    <div class="custom-row">
      <div class="custom-col custom-col--50 custom-col--sm-100 "
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['account_firstName'])"></div>
        <DefaultInput
            :label="$t('account_firstName.localization_value.value')"
            v-bind:class="{'ui-no-valid': account.validation.firstName}"
            :error="account.validation.firstName"
            :errorTxt="$t(`${account.validationTranslate.firstName}.localization_value.value`)"
            v-model="account.data.firstName"
        />
      </div>
      <div class="custom-col custom-col--50 custom-col--sm-100 "
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['account_lastName'])"></div>
        <DefaultInput
            :label="$t('account_lastName.localization_value.value')"
            v-bind:class="{'ui-no-valid': account.validation.lastName}"
            :error="account.validation.lastName"
            :errorTxt="$t(`${account.validationTranslate.lastName}.localization_value.value`)"
            v-model="account.data.lastName"
        />
      </div>
      <div class="custom-col custom-col--50 custom-col--sm-100 "
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['account_accountNumber'])"></div>
        <DefaultInput
            :label="$t('account_accountNumber.localization_value.value')"
            v-bind:class="{'ui-no-valid': account.validation.accountNumber}"
            :error="account.validation.accountNumber"
            :errorTxt="$t(`${account.validationTranslate.accountNumber}.localization_value.value`)"
            v-model="account.data.accountNumber"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DefaultInput from "../../../../../../UI/inputs/DefaultInput/DefaultInput";

export default {
  name: "Epayments",

  components: {
    DefaultInput,
  },

  props: {
    account: Object,
  },

  mounted() {
    this.account.setFieldsValid({
      firstName: true,
      lastName: true,
      accountNumber: true,
    })
  },
}
</script>

<style scoped>

</style>